import { getFingerPrint } from "@/utils/fingerPrint"
import { fetchAPI } from "@/api/api"
import { unreadResponseSchema } from "@/schemas/shared"
import { z } from "zod/v4"
import { stringParam, jsonParam } from "@/schemas/requestParams"

const ACCOUNT_TRACKER_API_URL = "/exchange/member/playerService/accountTracker"

// accountTracker (AccountTrackerBO.java:421-453)
const accountTrackerRequestSchema = z.strictObject({
  fingerprint2: stringParam(32).optional(),
  // JSON object (fingerprint, fingerprintCanvas, fingerprintWebGL, audio, fonts, hardware,
  // locales, math, permissions, plugins, screen, system, thumbmarkjsVersion); read only
  // while ENABLE_THUMBMARK_JS is on
  thumbmark: jsonParam(z.record(z.string(), z.unknown())).optional()
})

const getFingerprint2 = async (): Promise<string> => {
  // @ts-ignore
  const { default: TrafficStatistics2 } = await import("@/utils/trafficStatistics2.js")

  return new Promise(resolve => {
    new TrafficStatistics2().get(function cb(result: unknown) {
      resolve(result as string)
    })
  })
}

const fetch = {
  url: ACCOUNT_TRACKER_API_URL,
  handler: async () => {
    const { state: webSiteState } = useWebsiteInfoStore()

    // 原本fingerprint2應該要傳到fingerprint2欄位
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [fingerprint2, thumbmark] = await Promise.all([
      getFingerprint2(),
      getFingerPrint()
    ])

    const res = await fetchAPI({
      data: {
        fingerprint2: `isApp=${webSiteState.isApp}`,
        thumbmark: JSON.stringify(thumbmark)
      },
      url: ACCOUNT_TRACKER_API_URL,
      requestSchema: accountTrackerRequestSchema,
      schema: unreadResponseSchema
    })

    return res
  }
}

export default fetch
